// OCPP Templates translations for React Admin resource
export const ocppTemplatesResource = {
  name: 'OCPP 範本',
  fields: {
    id: 'ID',
    templateName: '範本名稱',
    description: '描述',
    ocppVersion: 'OCPP 版本',
    ocppProtocol: 'OCPP 協定',
    normalIntervalSeconds: '正常間隔（秒）',
    initialFastIntervalEnabled: '初始快速間隔',
    initialFastIntervalSeconds: '初始間隔（秒）',
    initialFastIntervalCount: '初始讀數數量',
    approachingIntervalEnabled: '啟用接近間隔',
    approachingThresholdSeconds: '接近閾值（秒）',
    approachingIntervalSeconds: '接近間隔（秒）',
    nearIntervalEnabled: '啟用臨近間隔',
    nearThresholdSeconds: '臨近閾值（秒）',
    nearIntervalSeconds: '臨近間隔（秒）',
    hysteresisEnabled: '啟用遲滯',
    hysteresisPercentage: '遲滯（%）',
    hysteresisMinutes: '遲滯（分鐘）',
    powerSmoothingEnabled: '功率平滑',
    powerSmoothingMethod: '平滑方法',
    powerSmoothingFactor: '功率平滑係數',
    isActive: '啟用',
    isDefault: '預設範本',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    createdBy: '建立者',
    usage: '使用情況',
    chargerCount: '分配的充電樁',
  },
};

// Custom OCPP templates translations for components
export const ocppTemplates = {
  show: {
    title: 'OCPP 範本詳情',
    subtitle: '查看和管理 OCPP 電表數值間隔配置',
  },
  defaultTemplate: '預設範本',
  create: {
    title: '建立 OCPP 範本',
    subtitle: '定義新的動態電表數值間隔範本',
    backToList: '返回 OCPP 範本列表',
  },
  edit: {
    title: '編輯 %{name}',
    subtitle: '修改電表數值間隔設定和配置',
    backToList: '返回 OCPP 範本列表',
  },
  tabs: {
    general: '基本資訊',
    intervals: '間隔配置',
    advanced: '進階設定',
    danger: '危險區域',
  },
  defaultTemplateNote: '這是新充電樁使用的預設範本',
  notInUse: '此範本目前未分配給任何充電樁',
  chargers: '個充電樁 |||| 個充電樁',
  charger: '充電樁',
  chargersPlural: '充電樁',
  chargersUsing: '使用此範本的充電樁',
  affectedChargers: '受影響的充電樁',
  ocppVersions: {
    '1.6': 'OCPP 1.6',
    '2.0.1': 'OCPP 2.0.1',
  },
  ocppProtocols: {
    json: 'JSON',
    soap: 'SOAP',
  },
  smoothingMethods: {
    weighted_average: '加權平均',
    moving_average: '移動平均',
    none: '無',
  },
  configuration: '配置',
  configExplanation: '正常間隔：%{normal}秒，接近：%{approaching}秒（當 < %{approachingThreshold}秒），臨近：%{near}秒（當 < %{nearThreshold}秒）',
  filters: {
    search: '按名稱或描述搜尋',
    activeOnly: '僅顯示啟用',
    defaultOnly: '預設範本',
    ocppVersion: 'OCPP 版本',
  },
  actions: {
    assignToCharger: '分配給充電樁',
    viewAssignedChargers: '查看分配的充電樁',
    setAsDefault: '設為預設',
  },
  sections: {
    basic: '基本資訊',
    intervals: '間隔配置',
    advanced: '進階設定',
    thresholds: '動態閾值',
    powerSmoothing: '功率計算',
    preview: '配置預覽',
    usage: '使用統計',
    metadata: '中繼資料',
    dangerZone: '危險區域',
  },
  helpers: {
    templateName: '此範本的唯一名稱',
    description: '範本用途的可選描述',
    ocppVersion: '此範本設計的 OCPP 協定版本',
    normalIntervalSeconds: '正常充電期間的預設電表數值報告間隔',
    initialFastIntervalEnabled: '啟用初始讀數的快速間隔以改善使用者體驗',
    initialFastIntervalSeconds: '前幾次電表讀數的間隔',
    initialFastIntervalCount: '切換到正常間隔前的快速間隔初始讀數數量',
    approachingThresholdMinutes: '觸發接近間隔的剩餘時間（分鐘）',
    nearThresholdMinutes: '觸發臨近間隔的剩餘時間（分鐘）',
    approachingIntervalSeconds: '接近充電目標時的電表數值間隔',
    nearIntervalSeconds: '非常接近充電目標時的電表數值間隔',
    hysteresisMinutes: '防止間隔振盪的緩衝時間（分鐘）',
    powerSmoothingFactor: '功率計算的平滑因子（0-1），0 表示無平滑，1 表示最大平滑',
    powerSmoothingEnabled: '啟用平滑以獲得穩定的功率計算',
    powerSmoothingMethod: '平滑功率讀數的演算法',
  },
  stats: {
    chargers: '充電樁',
    chargersDesc: '使用此範本的充電樁總數',
    totalPower: '總功率',
    totalPowerDesc: '管理的總功率容量',
    normalInterval: '正常間隔',
    normalIntervalDesc: '預設報告間隔',
  },
  normalInterval: '正常間隔',
  initialFastInterval: '初始快速間隔',
  approachingInterval: '接近間隔',
  nearInterval: '臨近間隔',
  intervalExplanation: '配置在不同充電階段電表數值報告的頻率。更頻繁的間隔提供更好的即時數據，但會增加網路流量。',
  hysteresis: '遲滯',
  hysteresisExplanation: '通過添加緩衝區防止間隔之間的快速切換。例如，20% 的遲滯，系統將等待閾值超過 20% 後才切換間隔。',
  powerSmoothing: '功率平滑',
  powerSmoothingExplanation: '對功率讀數應用加權平均以減少波動並提供更穩定的計算。較高的值提供更平滑的讀數，但可能降低響應性。',
  inUseWarning: '此範本目前已分配給充電樁。變更將立即影響其電表數值報告。',
  defaultTemplateInfo: '這是預設範本。它將自動分配給新的充電樁。',
  delete: {
    title: '刪除 OCPP 範本',
    content: '此範本將被永久刪除',
    hasChargersContent: '無法刪除已分配給充電樁的範本',
    isDefault: '無法刪除預設範本',
    warning: '警告：此操作無法復原',
    confirmMessage: '您即將刪除 OCPP 範本「%{name}」',
    typeToConfirm: '請在下方輸入「%{name}」以確認刪除：',
    nameDoesNotMatch: '名稱不符',
    button: '刪除範本',
  },
  validation: {
    nameTooLong: '名稱必須少於 255 個字元',
    descriptionTooLong: '描述必須少於 500 個字元',
    intervalTooLow: '間隔必須至少 %{min} 秒',
    intervalTooHigh: '間隔不能超過 %{max} 秒',
    thresholdTooLow: '閾值必須至少 %{min} 秒',
    thresholdTooHigh: '閾值不能超過 %{max} 秒',
    countTooLow: '計數必須至少 %{min}',
    countTooHigh: '計數不能超過 %{max}',
    hysteresisTooLow: '遲滯必須至少 %{min} 分鐘',
    hysteresisTooHigh: '遲滯不能超過 %{max} 分鐘',
    smoothingTooLow: '平滑因子必須至少 %{min}',
    smoothingTooHigh: '平滑因子不能超過 %{max}',
  },
  notifications: {
    created: 'OCPP 範本建立成功',
    updated: 'OCPP 範本更新成功',
    deleted: 'OCPP 範本刪除成功',
    deleteError: '刪除 OCPP 範本失敗',
    assigned: '範本分配給充電樁成功',
    setAsDefault: '範本設為預設成功',
  },
};